import React, { useState, useEffect, useRef } from "react";
import { FiHeart } from "react-icons/fi";
import { FaHeart, FaFire } from "react-icons/fa";
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io";
import { PiStorefrontLight } from "react-icons/pi";
import { WiTime12 } from "react-icons/wi";
import { X } from "lucide-react";
import { GiShoppingBag } from "react-icons/gi";
import { RiArrowDropDownLine } from "react-icons/ri";
import {
  FaStar,
  FaStarHalfAlt,
  FaMapMarkerAlt,
  FaFilter,
  FaTimes,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { addToCart, getCartCount } from "../../utils/cartUtils";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { toast } from "react-toastify";
import axios from "axios";
import { IoEyeSharp } from "react-icons/io5";
import { FaPlus, FaMinus } from "react-icons/fa";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { AiOutlineHeart } from "react-icons/ai";
import { FiPlus } from "react-icons/fi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { Helmet } from "react-helmet-async";


const ProductDetail1 = ({ data }) => {
  const simpleSlider = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
  };
  const scrollShopLookLeft = () => {
    shopLookSliderRef.current?.scrollBy({
      left: -320,
      behavior: "smooth",
    });
  };

  const scrollShopLookRight = () => {
    shopLookSliderRef.current?.scrollBy({
      left: 320,
      behavior: "smooth",
    });
  };

  const productsDetails = data["get_products_details"][0];
  const productImages =
    data?.get_products_details?.[0]?.product_images || [];

  const productSpecification =
    data["get_products_details"][0]["specification_details"];
  const sizes = data["get_products_details"][0]["size"];
  const sizePrice = data["get_products_details"][0]["get_price_lists"];
  const colors = data["color_products_lists"];
  const isCustomizable =
    data["get_products_details"][0]["Customizable"] === "Yes";

  const [selectedImage, setSelectedImage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  const [sortOption, setSortOption] = useState("Most Relevant"); // State for sorting option
  const [isSizeGuideModalOpen, setIsSizeGuideModalOpen] = useState(false);
  const navigate = useNavigate();
  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const [selectedTab, setSelectedTab] = useState("Size Chart");
  const [pincode, setPincode] = useState(
    sessionStorage.getItem("userPincode") || ""
  );
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [totalReviews, setTotalReviews] = useState(0);
  const [avgRating, setAvgRating] = useState(0);
  const [cartMessage, setCartMessage] = useState({ text: "", type: "" });
  const [isVibrating, setIsVibrating] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState({ text: "", type: "" });
  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");

  const [openReturn, setOpenReturn] = useState(false);
  const [openLookPopup, setOpenLookPopup] = useState(false);
  const shopLookSliderRef = useRef(null);

  // const productFaqs = data?.product_faqs;
  const [faqs, setFaqs] = useState([]);




  useEffect(() => {

    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }

    // console.log(productFaqs);
  }, []);


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  useEffect(() => {
    if (wishlistMessage.text) {
      const timer = setTimeout(() => {
        setWishlistMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [wishlistMessage.text]);

  useEffect(() => {
    if (cartMessage.text) {
      const timer = setTimeout(() => {
        setCartMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessage.text])

  useEffect(() => {
    const syncWishlistStatus = async () => {
      const token = sessionStorage.getItem("accessToken");

      if (!token || !productsDetails?.product_auto_id) {
        setWishlisted(false);
        return;
      }

      try {
        const wishlistArray = await getWishlistProducts();

        const isWishlisted = wishlistArray.some(
          (item) =>
            String(item.product_auto_id) ===
            String(productsDetails.product_auto_id)
        );

        setWishlisted(isWishlisted);
      } catch (error) {
        console.error("Wishlist sync failed:", error);
      }
    };

    syncWishlistStatus();
  }, [productsDetails.product_auto_id]);

  useEffect(() => {
    const fetchSizeChart = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (
          response.data.status === "1" &&
          response.data.getalldata.length > 0
        ) {
          const list = response.data.getalldata || [];

          // find normal chart
          const normalChart = list.find(
            item => item.chart_image && item.chart_image.trim() !== ""
          );

          // find international chart
          const internationalChart = list.find(
            item =>
              item.international_size_chart &&
              item.international_size_chart.trim() !== ""
          );

          if (normalChart) {
            setChartImage(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${normalChart.chart_image}`
            );
          }

          if (internationalChart) {
            setChartImage2(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChart.international_size_chart}`
            );
          }

        }
      } catch (error) {
        console.error("Failed to load size chart:", error);
      }
    };
    // Fetch reviews from API
    const fetchReviews = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Ratings`,
          {
            product_auto_id: productsDetails.product_auto_id,
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
          }
        );

        if (response.data.status === 1) {
          setReviews(response.data.getalldata || []);
          setTotalReviews(response.data.total_no_of_reviews || 0);
          setAvgRating(response.data.avg_rating || 0);
        } else {
          console.error("Failed to fetch reviews:", response.data);
          setReviews([]);
          setTotalReviews(0);
          setAvgRating(0);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews([]);
        setTotalReviews(0);
        setAvgRating(0);
      }
    };

    fetchSizeChart();
    fetchReviews();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isSizeGuideModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen]);


  // Function to toggle Size Guide Modal
  const toggleSizeGuideModal = () =>
    setIsSizeGuideModalOpen(!isSizeGuideModalOpen);

  const handleSortChange = (event) => {
    setSortOption(event.target.value); // Update the sort option when selected
  };

  const handlePrev = () => {
    setSelectedImage((prev) =>
      prev > 0 ? prev - 1 : productImages.length - 1
    );
  };

  const handleNext = () => {
    setSelectedImage((prev) =>
      prev < productImages.length - 1 ? prev + 1 : 0
    );
  };

  const [selectedSize, setSelectedSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(
    productsDetails.final_product_price
  );
  const [currentOffer, setCurrentOffer] = useState(
    productsDetails.offer_percentage
  );
  const [originalPrice, setOriginalPrice] = useState(
    productsDetails.product_price
  );
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);

  const handleSizeSelect = (size, index) => {
    setSelectedSize(size.size_name);
    setSelectedSizeId(size.size_auto_id);
    setSelectedStock(parseInt(size.size_stock, 10));
    const selectedPrice = sizePrice[index];
    if (selectedPrice) {
      setCurrentPrice(selectedPrice.final_size_price);
      setOriginalPrice(selectedPrice.size_price);
      setCurrentOffer(selectedPrice.offer_percentage);
    }
  };

  const [wishlisted, setWishlisted] = useState(false);


  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    setIsVibrating(false);
    setWishlistMessage({ text: "", type: "" });
    try {
      if (wishlisted) {
        // If currently wishlisted, remove it
        const res = await removeFromWishlist(productsDetails.product_auto_id);
        if (res?.status === 1) {
          setWishlisted(false);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add", type: "error" });
          }
        }
      } else {
        // If not wishlisted, add it
        const res = await addToWishlist(productsDetails.product_auto_id);
        if (res?.status === "1") {
          setWishlisted(true);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add", type: "error" });
          }
        }

      }
    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };

  const products = data["get_similar_product_lists"];

  const handleCheckPincode = async (pin) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: admin_auto_id,
        }
      );

      if (response.data.status === 1) {
        const pincodeList = response.data.get_pincode_list.map(
          (item) => item.pincode
        );
        if (pincodeList.includes(pin.trim())) {
          setMessage(`Good news! We deliver to ${pin}.`);
          setMessageColor("text-green-600");
          sessionStorage.setItem("userPincode", pin.trim()); // Save valid pincode
        } else {
          setMessage(`Sorry, currently we are unable to deliver at ${pin}.`);
          setMessageColor("text-red-600");
        }
      } else {
        setMessage("Failed to fetch delivery data.");
        setMessageColor("text-red-600");
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
      setMessageColor("text-red-600");
    } finally {
      setLoading(false);
    }
  };

  // New useEffect for automatic pincode checking
  useEffect(() => {
    if (pincode && pincode.length >= 6 && pincode.length <= 8) {
      handleCheckPincode(pincode);
    } else if (pincode && (pincode.length < 6 || pincode.length > 8)) {
      sessionStorage.removeItem("userPincode");
      setPincode("");
    }
  }, []); // Run only on mount

  // New pincode input handler
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPincode(value);
    if (value.length >= 6 && value.length <= 8) {
      handleCheckPincode(value);
    } else if ((value.length < 6 || value.length > 8) && message) {
      setMessage(""); // Clear message if pincode is invalid
      setMessageColor("");
    }
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} className="w-4 h-4 text-black" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="w-4 h-4 text-black" />);
    }
    return stars;
  };

  // Sort reviews based on sortOption
  const sortedReviews = [...reviews].sort((a, b) => {
    if (sortOption === "Most Newest") {
      return new Date(b.date) - new Date(a.date);
    } else if (sortOption === "Highest Rated") {
      return b.rating - a.rating;
    }
    return 0; // "Most Relevant" can be a default or custom logic
  });

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  // Function to format SKU to exactly 8 characters using only product_model_auto_id
  const formatSKU = (modelId) => {
    const rawSKU = modelId ? modelId.toString() : '';
    if (rawSKU.length > 8) {
      return rawSKU.slice(0, 8);
    }
    return rawSKU.padEnd(8, '0');
  };

  const [isBoughtFactual, setIsBoughtFactual] = useState(false);
  const [isProductViewsFactual, setIsProductViewsFactual] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);

  // State to control which messages to show
  const [showMessages, setShowMessages] = useState(false);
  const [showBought, setShowBought] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsBoughtFactual(apiData.is_bought_factual);
          setIsProductViewsFactual(apiData.is_product_views_factual);
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isMarketingKeysLoading) {
      console.log("Waiting for marketing keys to load...");
      return;
    }

    const shouldShowMessages = Math.random() < 0.9;
    setShowMessages(shouldShowMessages);

    if (shouldShowMessages) {
      const randomChoice = Math.random();
      if (randomChoice < 0.33) {
        setShowBought(true);
        setShowViews(false);
      } else if (randomChoice < 0.66) {
        setShowBought(false);
        setShowViews(true);
      } else {
        setShowBought(true);
        setShowViews(true);
      }
    } else {
      setShowBought(false);
      setShowViews(false);
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock) {
      const stock = parseInt(quantityLeftFactualValue, 10);

      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(sizes.map(() => 0));

      } else {
        const newRandomStocks = sizes.map(() => Math.floor(Math.random() * stock) + 1);
        setRandomStocks(newRandomStocks);

      }
    } else {
      const originalStocks = sizes.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);

    }
  }, [productsDetails.available_stock, sizes, quantityLeftFactualValue, isMarketingKeysLoading]);

  const getRandomBoughtCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const getRandomViewCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const [crossSellingProducts, setCrossSellingProducts] = useState([]);
  const [crossSellingLoading, setCrossSellingLoading] = useState(false);
  const [crossSellingStartIndex, setCrossSellingStartIndex] = useState(0);
  const [selectedCrossProduct, setSelectedCrossProduct] = useState(null);
  const [crossSelectedSize, setCrossSelectedSize] = useState(null);
  const [crossSelectedSizeId, setCrossSelectedSizeId] = useState(null);
  const [crossSelectedStock, setCrossSelectedStock] = useState(null);
  const [crossQuantity, setCrossQuantity] = useState(1);
  const [crossSelectedSizePrice, setCrossSelectedSizePrice] = useState(null);
  const [crossShowSizeChart, setCrossShowSizeChart] = useState(false);
  const [crossMessage, setCrossMessage] = useState(null);


  useEffect(() => {
    if (isSizeGuideModalOpen || selectedCrossProduct) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen, selectedCrossProduct]);


  // Fetch cross-selling products
  useEffect(() => {
    const fetchCrossSellingProducts = async () => {
      const crossSellingIds = productsDetails.cross_selling_products
        ? productsDetails.cross_selling_products.split("|").filter((id) => id)
        : [];
      if (crossSellingIds.length === 0) {
        setCrossSellingProducts([]);
        return;
      }
      setCrossSellingLoading(true);
      try {
        const products = [];
        for (const product_auto_id of crossSellingIds) {
          const formData = new FormData();
          formData.append("admin_auto_id", admin_auto_id);
          formData.append("app_type_id", app_type_id);
          formData.append("user_auto_id", admin_auto_id);
          formData.append("product_auto_id", product_auto_id);
          formData.append("customer_auto_id", admin_auto_id);
          formData.append("sub_category_auto_id", admin_auto_id);
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_product_details`, {
            method: "POST",
            body: formData,
          });
          if (!response.ok) {
            console.error(`Failed to fetch product details for ID: ${product_auto_id}`);
            continue;
          }
          const responseData = await response.json();
          if (responseData?.get_products_details?.[0]) {
            products.push({
              ...responseData.get_products_details[0],
              images: responseData.get_products_details[0].product_images.map(
                (img) => `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
              ),
              price: responseData.get_products_details[0].final_product_price,
              originalPrice: responseData.get_products_details[0].product_price,
              discount: `${responseData.get_products_details[0].offer_percentage}% off`,
              productAutoId: responseData.get_products_details[0].product_auto_id,
              name: responseData.get_products_details[0].product_name,
              user_auto_id: responseData.get_products_details[0].user_auto_id,
              description: responseData.get_products_details[0].description,
              size: responseData.get_products_details[0].size,
              get_price_lists: responseData.get_products_details[0].get_price_lists,
              moq: responseData.get_products_details[0].moq,
            });
          }
        }
        setCrossSellingProducts(products);
      } catch (error) {
        console.error("Error fetching cross-selling products:", error);
        setCrossSellingProducts([]);
      } finally {
        setCrossSellingLoading(false);
      }
    };
    if (productsDetails.cross_selling_products) {
      fetchCrossSellingProducts();
    }
  }, [productsDetails.cross_selling_products, admin_auto_id, app_type_id]);

  const clearCrossMessage = () => {
    setTimeout(() => {
      setCrossMessage(null);
    }, 2000);
  };

  useEffect(() => {
    if (isMarketingKeysLoading || !selectedCrossProduct) {
      return;
    }
    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);
    if (shouldShowStock && selectedCrossProduct.size?.length > 0) {
      const stock = parseInt(quantityLeftFactualValue, 10);
      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(selectedCrossProduct.size.map(() => 0));
      } else {
        const newRandomStocks = selectedCrossProduct.size.map(() => Math.floor(Math.random() * stock) + 1);
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = selectedCrossProduct.size.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);
    }
  }, [isMarketingKeysLoading, selectedCrossProduct, quantityLeftFactualValue]);

  const fetchCrossSizeChart = async () => {
    if (crossShowSizeChart) {
      setCrossShowSizeChart(false);
      return;
    }
    if (chartImage) {
      setCrossShowSizeChart(true);
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        {
          admin_auto_id,
          app_type_id,
        }
      );
      if (response.data.status === "1" && response.data.getalldata.length > 0) {
        const img = response.data.getalldata[0].chart_image;
        const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img}`;
        const img2 = response.data.getalldata[0].international_size_chart;
        const imageUrl2 = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img2}`;
        setChartImage(imageUrl);
        setChartImage2(imageUrl2);
        setCrossShowSizeChart(true);
      } else {
        setCrossMessage("Size chart not available.");
      }
    } catch (error) {
      console.error("Failed to load size chart:", error);
    } finally {
      clearCrossMessage();
    }
  };




  useEffect(() => {
    if (Array.isArray(data?.product_faqs)) {
      const formattedFaqs = data.product_faqs
        .filter(item => item?.question && item?.answer)
        .map(item => ({
          question: item.question,
          answer: item.answer,
        }));

      setFaqs(formattedFaqs);
      console.log("FAQs:", faqs);

    }
  }, [data]); // 👈 VERY IMPORTANT



  return (
    <>
      <Helmet>
        {/* 🔹 Dynamic Title */}
        <title>
          {productsDetails?.product_name
            ? `${productsDetails.product_name} `
            : "Product Details"}
        </title>

        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content={
            productsDetails?.description
              ? productsDetails.description
                .replace(/(<([^>]+)>)/gi, "")
              : "Buy products online at best price."
          }
        />

        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content={
            productsDetails?.keywords
              ? productsDetails.keywords
              : "online shopping, ecommerce product"
          }
        />



        {/* 🔹 PRODUCT SCHEMA (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: productsDetails?.product_name,
            description: productsDetails?.description
              ?.replace(/(<([^>]+)>)/gi, "")
              .slice(0, 160),
            image: productsDetails?.product_images?.map(
              (img) =>
                `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
            ),
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: productsDetails?.final_product_price,
              availability:
                productsDetails?.available_stock > 0
                  ? "https://schema.org/InStock"
                  : "https://schema.org/OutOfStock",
            },
          })}

        </script>





      </Helmet>

      <style>
        {`
          @keyframes wiggle {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-3px); }
            50% { transform: translateX(3px); }
            75% { transform: translateX(-3px); }
          }
          .wiggle {
            animation: wiggle 0.2s ease-in-out 3;
          }
          .disabled-overlay::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 8%;
            right: 8%;
            height: 1px;
            background-color: #9ca3af; /* gray-400 */
            transform: translateY(-50%);
            pointer-events: none;
          }
            .vertical-gradient-text {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-weight: 750;
  font-size: 50px;
  text-transform: uppercase;
  background: linear-gradient(
    to bottom,
    #1a1a1a 0%,
    #8b8b8b 35%,
    #d0d0d0 50%,
    #8b8b8b 70%,
    #1a1a1a 100%
  );
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: 0px;
}
.faq-section {
  margin-top: 40px;
}

.faq-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.faq-item {
  margin-bottom: 16px;
}

.faq-question {
  font-weight: 600;
  font-size: 16px;
}

.faq-answer {
  margin-top: 6px;
  color: #555;
}


        `}
      </style>
      <div className="block px-0 pt-0 bg-white md:hidden">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="w-full"
        >
          {productImages.map((image) => (
            <SwiperSlide key={image.image_auto_id}>
              <div
                className="relative w-full overflow-hidden bg-white cursor-zoom-in"
                onMouseMove={(e) => {
                  const img = e.currentTarget.querySelector("img");
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = ((e.clientX - rect.left) / rect.width) * 100;
                  const y = ((e.clientY - rect.top) / rect.height) * 100;
                  img.style.transformOrigin = `${x}% ${y}%`;
                  img.style.transform = "scale(2)";
                }}
                onMouseLeave={(e) => {
                  const img = e.currentTarget.querySelector("img");
                  img.style.transformOrigin = "center";
                  img.style.transform = "scale(1)";
                }}
              >
                <img
                  src={
                    image?.product_image
                      ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${image.product_image}`
                      : "https://placehold.co/480x600"
                  }

                  alt="Product"
                  className="
              w-full
              h-[480px]
              object-cover
              transition-transform
              duration-300
              ease-in-out
            "
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>


      <div className={`flex flex-col justify-center gap-6 p-6 lg:flex-row  ${webFont}`}>
        {/* Image Section */}

        <div className={`flex items-center justify-center h-full mb-4 hidden md:block`}>
          {/* Show Multiple Images in a Grid */}
          <div className="grid grid-cols-2 gap-2 w-full max-w-[950px]">
            {productImages
              .slice(selectedImage, selectedImage + 4)
              .map((image) => (
                <div
                  key={image.image_auto_id}
                  className="relative w-auto max-w-64 h-[250px] md:h-[400px] overflow-hidden group"
                  onMouseMove={(e) => {
                    const img = e.currentTarget.querySelector("img");
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = ((e.clientX - rect.left) / rect.width) * 100;
                    const y = ((e.clientY - rect.top) / rect.height) * 100;
                    img.style.transformOrigin = `${x}% ${y}%`;
                  }}
                  onMouseLeave={(e) => {
                    const img = e.currentTarget.querySelector("img");
                    img.style.transformOrigin = 'center';
                  }}
                >
                  <img
                    src={
                      image?.product_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${image.product_image}`
                        : "https://placehold.co/480x600"
                    }

                    alt={`Product Image ${selectedImage + 1}`}
                    className="w-full h-full object-cover transition-transform duration-300 ease-in-out transform group-hover:scale-[2]"
                  />
                </div>
              ))}
          </div>
        </div>


        {/* Details Section */}
        <div className="lg:w-1/2 ">
          <div className="p-0 sm:p-6">
            <div className="flex items-center">
              {/* Product Title */}
              <h1 className="text-2xl font-bold">
                {productsDetails.product_name}{" "}
              </h1>

              {/* Like Button (Heart Icon) */}
              <div className="relative">
                <button
                  onClick={handleWishlistToggle}
                  className={`ml-10 sm:ml-24 p-1 rounded-full ${wishlisted ? "text-red-500" : "text-gray-500"} ${isVibrating ? "wiggle" : ""}`}
                  key={isVibrating ? `vibrate-${Date.now()}` : 'no-vibrate'}
                >
                  {wishlisted ? (
                    <FaHeart className="w-6 h-6" />
                  ) : (
                    <FiHeart className="w-6 h-6" />
                  )}
                </button>
                {wishlistMessage.text && (
                  <div
                    className={`absolute left-0 right-0 top-8 text-center p-1 text-xs ${wishlistMessage.type === "error" ? "text-red-500" : "text-green-500"
                      }`}
                  >
                    {wishlistMessage.text}
                  </div>
                )}
              </div>
            </div>


            <p className="text-xs text-gray-500">{productsDetails.including_tax === "Yes" ? "MRP inclusive of all taxes" : "MRP exclusive of all taxes"}</p>

            {/* <p className="mb-1 text-gray-500">White/Rick and Morty</p> */}
            <p className="text-gray-500">
              SKU: {formatSKU(productsDetails.product_model_auto_id)}
            </p>

            <div className="mt-1">
              {showBought && isBoughtFactual && (
                <p className="flex items-center text-sm font-medium font-extrabold text-black">
                  {getRandomBoughtCount(productsDetails.bought_count)}+  bought this !
                </p>
              )}
            </div>

            <p className="text-xl font-semibold " style={{ color: themeColor }}>
              ₹{currentPrice}
              {parseInt(currentOffer) > 0 && (
                <>
                  {" "}
                  <span className="ml-2 text-gray-400 line-through">
                    ₹{originalPrice}
                  </span>
                  <span className="px-2 py-1 ml-2 text-sm text-white" style={{ backgroundColor: themeColor }}>
                    {currentOffer}% OFF
                  </span>
                </>
              )}
            </p>
            {/* Thumbnail Images in Vertical Grid */}
            <h1 className="text-base text-semibold">
              {productsDetails.country_of_origin}
            </h1>
            <div className="flex items-center hidden gap-4 md:block">
              {/* Left Arrow */}
              <button onClick={handlePrev} className="p-2 rounded-full ">
                <IoIosArrowRoundBack size={20} />
              </button>

              {/* Thumbnails */}
              <div className="flex gap-4 overflow-hidden">
                {productImages.map((image, index) => (
                  <img
                    key={image.image_auto_id}
                    src={
                      image?.product_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${image.product_image}`
                        : "https://placehold.co/100x100"
                    }

                    alt={image.product_image}
                    className={`h-20 w-20 object-cover cursor-pointer border  transition-all duration-200 
                        ${selectedImage === index
                        ? "border-black"
                        : "border-gray-200"
                      }`}
                    onClick={() => setSelectedImage(index)}
                  />
                ))}
              </div>

              {/* Right Arrow */}
              <button onClick={handleNext} className="p-2 rounded-full ">
                <IoIosArrowRoundForward size={20} />
              </button>
            </div>

            {colors && colors.length > 0 && (
              <div className="flex flex-col mt-2 space-y-1">
                <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                <div className="flex mt-1 space-x-2">
                  {colors.map((color) => (
                    <Link
                      to={`/product-detail/${color.product_auto_id}`}
                      key={color.product_auto_id}
                      className="w-8 h-8 border border-gray-300 rounded-full shadow-sm cursor-pointer"
                      style={{
                        backgroundColor: color.color_code
                          ? color.color_code
                            .replace("Color(0xff", "#")
                            .replace(")", "")
                          : "#000000", // Fallback color if color_code is null/undefined
                      }}
                      title={color.color_name}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* {colors && colors.length > 0 && (
                <div className="flex flex-col mt-4 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                  <div className="flex mt-2 space-x-3">
                    {colors.map((color) => {
                      const imageUrl = color.color_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                        : 'https://via.placeholder.com/400x400?text=No+Image';
                      return (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="relative w-16 overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer h-28"
                          title={color.color_name}
                          onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                          style={{ borderColor: lightenHexColor(themeColor,0.2) }}
                        onMouseEnter={(e) => {
                          const darkenedColor = darkenHexColor(themeColor, 0.15); 
                          e.currentTarget.style.borderColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = lightenHexColor(themeColor,0.2) ;
                        }}
                          
                        >
                          <img
                            src={imageUrl}
                            alt={color.color_name || 'Color Image'}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              console.error(`Failed to load image: ${imageUrl}`);
                              e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                            }}
                          />
                          
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )} */}


            <div className="mt-4">
              {sizes?.length > 0 && (
                <>
                  <h3 className="mb-2 text-sm font-semibold">Select</h3>
                  <div className="flex mt-4 space-x-2">
                    {sizes.map((size, index) => {
                      const actualStock = parseInt(size.size_stock, 10);
                      const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
                      const isSelected = selectedSize === size.size_name;

                      const displayStock = showStock ? randomStocks[index] : actualStock;
                      const showStockLabel =
                        actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;

                      return (
                        <div key={size.product_auto_id} className="relative">
                          <button
                            className={`relative border w-14 h-12 sm:w-20 text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                            style={{
                              backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                              borderColor: !isDisabled && isSelected ? themeColor : undefined,
                              color: !isDisabled && isSelected ? "#ffffff" : undefined,
                              position: "relative",
                            }}
                            onClick={() => !isDisabled && handleSizeSelect(size, index)}
                            onMouseEnter={(e) => {
                              if (!isSelected && !isDisabled) {
                                e.currentTarget.style.backgroundColor = themeColor;
                                e.currentTarget.style.color = "#ffffff";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSelected && !isDisabled) {
                                e.currentTarget.style.backgroundColor = "#ffffff";
                                e.currentTarget.style.color = "#000000";
                              }
                            }}
                            disabled={isDisabled}
                          >
                            {/* SIZE TEXT */}
                            <span
                              className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                            >
                              {size.size_name}
                            </span>

                            {/* STOCK LABEL */}
                            {showStockLabel && (
                              <span
                                className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                style={{ backgroundColor: themeColor }}
                              >
                                {displayStock} left
                              </span>
                            )}

                            {/* CROSS (X) LINES FOR DISABLED */}
                            {isDisabled && (
                              <>
                                {/* Line 1 */}
                                <span
                                  className="absolute w-[130%] h-[1px] bg-gray-400 left-1/2 top-1/2"
                                  style={{
                                    transform: "translate(-50%, -50%) rotate(35deg)",
                                  }}
                                ></span>



                              </>
                            )}
                          </button>
                        </div>
                      );
                    })}
                  </div>

                </>
              )}

              {/* Size Guide Button */}
              {(chartImage || chartImage2) && (
                <button
                  onClick={toggleModal}
                  className="py-2 text-sm font-semibold underline hover:text-gray-500"
                >
                  {/* <FaRuler className="w-3 h-3" /> */}
                  Size Guide
                </button>
              )}



              {/* Size Out of Stock Button */}
              {/* <button
                onClick={toggleOutOfStockModal}
                className="mb-4 text-sm font-semibold underline hover:text-gray-500 ml-96 "
              >
                Size Out of Stock?
              </button> */}

              {/* Modal for Size Guide */}
              {isSizeGuideModalOpen && (
                <div className="fixed inset-0 flex justify-end">
                  {/* Click Outside to Close */}
                  <div
                    className="flex-1 bg-black bg-opacity-50"
                    onClick={toggleSizeGuideModal}
                  ></div>

                  {/* Sidebar Modal */}
                  <div className="w-1/3 h-full p-6 overflow-y-auto transition-transform duration-300 bg-white shadow-lg">
                    {/* Close Button */}
                    <button
                      onClick={toggleSizeGuideModal}
                      className="absolute top-4 right-4"
                    >
                      <X size={24} />
                    </button>

                    <h2 className="mb-4 text-lg font-bold">Size Chart</h2>
                    {/* Size Chart Content */}
                  </div>
                </div>
              )}

              {/* Modal for Out of Stock */}
              {/* {isOutOfStockModalOpen && (
                <div className="fixed inset-0 z-50 flex items-start justify-center">
                 
                  <div className="w-full p-6 transition-transform duration-300 ease-in-out transform translate-y-full bg-white shadow-lg sm:w-96 rounded-b-md">
                   
                    <button
                      onClick={toggleOutOfStockModal}
                      className="absolute text-xl text-gray-600 top-4 right-4"
                    >
                      ×
                    </button>

                    <h2 className="text-lg font-bold text-center">Notify me</h2>
                    <p className="mt-2 text-center text-gray-600">
                      DON'T MISS OUT! {productsDetails.Stock_alert_limit}{" "}
                    </p>
                    <p className="mt-2 text-center text-gray-500">
                      Get notified if your product comes back in stock — it's
                      easy!
                    </p>

                    <div className="mt-4 text-center">
                      <button
                        className="px-6 py-2 font-semibold text-white bg-black rounded-md hover:bg-gray-800"
                        onClick={() => alert("Redirect to sign in")}
                      >
                        Sign in / Join
                      </button>
                    </div>
                  </div>
                </div>
              )} */}

              <div className="mt-4 mb-4">
                <p className="flex items-center font-semibold text-gray-500">
                  <FaMapMarkerAlt className="mr-2" size={18} /> Check
                  Availability
                </p>
                <div className="flex items-center mt-2">
                  <input
                    type="text"
                    placeholder="Enter pincode"
                    value={pincode}
                    onChange={handlePincodeChange}
                    className="w-3/4 px-2 py-1 text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    maxLength={8} // Allow up to 8 digits
                    disabled={loading}
                  />
                </div>
                {loading && (
                  <p className="mt-2 text-sm font-medium text-gray-600">
                    Checking availability...
                  </p>
                )}
                {message && (
                  <p
                    className={`mt-2 text-base font-semibold ${messageColor}  p-2 rounded-lg `}
                  >
                    {message}
                  </p>
                )}
              </div>

              {isCustomizable && (
                <div className="mt-4 mb-4">
                  <p className="flex items-center font-semibold text-gray-500">
                    <span className="mr-2">📷</span> Customize Your Product
                  </p>
                  <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                    <p className="mb-2 text-sm text-gray-600">
                      Upload an image to personalize your{" "}
                      {productsDetails.product_name}
                    </p>
                    <div className="flex items-center gap-4">
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleImageUpload}
                        className="hidden"
                        id="image-upload"
                      />
                      <label
                        htmlFor="image-upload"
                        className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                        style={{ backgroundColor: themeColor }}
                        onMouseEnter={(e) => {
                          const darkenedColor = lightenHexColor(themeColor, 0.1);
                          e.currentTarget.style.backgroundColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = themeColor;
                        }}
                      >
                        Choose Image
                      </label>
                      {imagePreview && (
                        <div className="flex items-center gap-2">
                          <img
                            src={imagePreview}
                            alt="Preview"
                            className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                          />
                          <button
                            onClick={handleRemoveImage}
                            className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                            aria-label="Remove uploaded image"
                          >
                            <FaTimes size={16} />
                          </button>
                        </div>
                      )}
                    </div>
                    {uploadedImage && (
                      <p className="mt-2 text-sm text-green-600">
                        Image uploaded: {uploadedImage.name}
                      </p>
                    )}
                    <p className="mt-2 text-xs text-gray-500">
                      Supported formats: JPG, PNG, GIF.
                    </p>
                  </div>
                </div>
              )}

              <div className="relative mt-4">
                {cartMessage.text && (
                  <div
                    className={`absolute left-0 right-0 top-[-2rem] text-center p-2 text-sm ${cartMessage.type === "error" ? "text-red-500" : "text-green-500"
                      }`}
                  >
                    {cartMessage.text}
                  </div>
                )}
                {/* Add to Bag Button */}
                <button
                  style={{
                    backgroundColor: sizes?.length > 0 && !selectedSize ? "#9CA3AF" : themeColor, // #9CA3AF is bg-gray-400
                    color: "white",
                    cursor: sizes?.length > 0 && !selectedSize ? "not-allowed" : "pointer",
                  }}
                  onMouseEnter={(e) => {
                    if (!(sizes?.length > 0 && !selectedSize)) {
                      const darkenedColor = lightenHexColor(themeColor, 0.1); // Darken to mimic hover:bg-gray-800
                      e.currentTarget.style.backgroundColor = darkenedColor;
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      sizes?.length > 0 && !selectedSize ? "#9CA3AF" : themeColor;
                  }}
                  className="flex items-center justify-center block w-full gap-2 py-2 mt-1 font-semibold transition-colors duration-200"
                  onClick={async () => {
                    if (sizes?.length === 0 || selectedSize) {
                      try {
                        const payload = {
                          product_auto_id: productsDetails?.product_auto_id,
                          added_by_id: productsDetails?.user_auto_id,
                          cart_quantity:
                            productsDetails?.moq && productsDetails.moq !== ""
                              ? productsDetails.moq
                              : 1,
                          ...(sizes?.length !== 0 && {
                            size: selectedSizeId,
                            size_price: currentPrice,
                          }),
                          ...(isCustomizable &&
                            uploadedImage && { cust_image: uploadedImage }),
                        };

                        const res = await addToCart(payload);

                        // 🚫 ALREADY IN CART → CHECK FIRST
                        if (res?.message && res.message.toLowerCase().includes("already")) {
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });
                          return; // ⛔ STOP here, no navigation
                        }

                        // ✅ SUCCESS
                        if (res?.status === "1") {
                          setCartMessage({
                            text: res.message || "Added to cart",
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setCartMessage({
                            text: res?.message || "Unable to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                      }
                    } else {
                      setCartMessage({ text: "Select a Size", type: "error" });
                    }
                  }}

                  disabled={sizes?.length > 0 && !selectedSize} // disable button when size is required but not selected
                >
                  <GiShoppingBag className="w-3 h-3" />
                  {sizes?.length > 0 && !selectedSize
                    ? "Select Size"
                    : `Add | ₹ ${currentPrice}`}
                </button>

                <div className="mt-2 space-y-2">
                  {showViews && isProductViewsFactual && (
                    <p className="flex items-center justify-center text-sm font-medium text-black00">
                      <IoEyeSharp className="mr-1" size={18} />
                      {getRandomViewCount(productsDetails.view_count)} people are viewing this item. Don’t wait!
                    </p>
                  )}
                </div>

                {crossSellingProducts.length > 0 && (
                  <div className={`flex flex-col mt-4 space-y-2 ${webFont}`}>
                    <label className="text-sm font-medium text-gray-700">Model is also wearing:</label>
                    <div className="flex mt-2 space-x-3">
                      {crossSellingProducts.map((product) => {
                        const imageUrl = product.images?.length > 0
                          ? product.images[0]
                          : 'https://via.placeholder.com/400x400?text=No+Image';
                        return (
                          <div
                            key={product.productAutoId}
                            className="relative flex flex-col items-center w-24 overflow-visible transition-all duration-200 cursor-pointer"
                            title={product.name}
                            onClick={() => setSelectedCrossProduct(product)}
                          >
                            <img
                              src={imageUrl}
                              alt={product.name || 'Product Image'}
                              className="object-cover w-full h-28"
                              onError={(e) => {
                                console.error(`Failed to load image: ${imageUrl}`);
                                e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                              }}
                            />
                            <p className="w-full mt-1 text-xs text-center text-gray-700 break-words truncate">{product.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Right Side Full Height Modal */}
              {isOpen && (
                <div className="fixed inset-0 z-30 flex justify-end">
                  {/* Click Outside to Close */}
                  <div
                    className="flex-1 bg-black bg-opacity-50"
                    onClick={toggleModal}
                  ></div>

                  {/* Sidebar Modal */}
                  <div className="w-[400px] h-full bg-white shadow-lg p-6 overflow-y-auto transition-transform duration-300 relative">
                    {/* Close Button */}
                    <button
                      onClick={toggleModal}
                      className="absolute text-gray-500 top-4 right-4 hover:text-black"
                    >
                      <X size={24} />
                    </button>

                    <h2 className="mb-4 text-lg font-bold text-center text-black">
                      Size Chart
                    </h2>

                    {/* Tabs */}
                    <div className="flex mb-6 border-b">
                      {["Size Chart", "International Size Chart"].map((tab) => (
                        <button
                          key={tab}
                          onClick={() => setSelectedTab(tab)}
                          className={`flex-1 text-center py-2 font-medium transition-all ${selectedTab === tab
                            ? "border-b-2"
                            : "text-gray-600"
                            }`}
                          style={{ color: selectedTab === tab ? themeColor : "", borderColor: selectedTab === tab ? themeColor : "" }}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>

                    {/* Tab Content */}
                    <div className="space-y-6">
                      {selectedTab === "Size Chart" &&
                        (chartImage ? (
                          <img
                            src={chartImage}
                            alt="Size Chart"
                            className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                          />
                        ) : (
                          <p className="text-sm text-center text-gray-500">
                            Chart not available.
                          </p>
                        ))}

                      {selectedTab === "International Size Chart" &&
                        (chartImage2 ? (
                          <img
                            src={chartImage2}
                            alt="International Size Chart"
                            className="w-full transition-transform duration-300 border rounded-md shadow-sm "
                          />
                        ) : (
                          <p className="text-sm text-center text-gray-500">
                            International chart not available.
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-4 sm:hidden">
              <button
                onClick={() => setOpenReturn(!openReturn)}
                className="flex items-center justify-between w-full px-3 py-2 text-sm font-medium bg-gray-100 rounded-md"
              >
                <span>Return & Exchange</span>
                <span>{openReturn ? "▲" : "▼"}</span>
              </button>

              {openReturn && (
                <div className="px-3 py-2 mt-2 space-y-2 text-sm text-gray-600 rounded-md bg-gray-50">

                  {/* Delivery Time */}
                  {productsDetails?.time && productsDetails?.time_unit && (
                    <p className="flex items-center gap-1 ">
                      <WiTime12 className="w-5 h-5" />
                      Delivery Time: {productsDetails.time} {productsDetails.time_unit}
                    </p>
                  )}

                  {/* Return */}
                  <p className="flex items-center gap-1">
                    <span className="font-medium">Return:</span>
                    {productsDetails?.isReturn === "Yes" ? "Available" : "Not Available"}
                  </p>

                  {/* Exchange */}
                  <p className="flex items-center gap-1">
                    <span className="font-medium">Exchange:</span>
                    {productsDetails?.isExchange === "Yes" ? "Available" : "Not Available"}
                  </p>

                </div>
              )}
            </div>
            {/* Clickable Text to Open Modal */}
            {productsDetails?.time && productsDetails?.time_unit && (
              <p className="flex items-center hidden gap-1 pt-4 text-sm text-gray-500 sm:block">
                <WiTime12 className="w-5 h-5" />
                Delivery Time: {productsDetails.time} {productsDetails.time_unit}
              </p>
            )}

            {/* Return Available */}
            <p className="flex items-center hidden gap-1 text-sm text-gray-500 sm:block">
              <span className="font-medium">Return:</span>{" "}
              {productsDetails?.isReturn === "Yes" ? "Available" : "Not Available"}
            </p>

            {/* Exchange Available */}
            <p className="flex items-center hidden gap-1 text-sm text-gray-500 sm:block">
              <span className="font-medium">Exchange:</span>{" "}
              {productsDetails?.isExchange === "Yes" ? "Available" : "Not Available"}
            </p>

            {/* Star Rating with Clickable Reviews */}
            {/* <div>
  <button
  onClick={() => setIsReviewOpen(true)}
  className="flex items-center gap-1 px-3 py-1 mt-2 text-black transition bg-orange-200 border border-gray-400 rounded-lg md:bg-transparent md:hover:bg-orange-200"

>
  {renderStars(avgRating)}
  <span>
    {totalReviews} reviews
  </span>
</button>


  
  {isReviewOpen && (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div
        className="flex-1 bg-black bg-opacity-50"
        onClick={() => setIsReviewOpen(false)}
      ></div>

      
      <div
        className="
          w-[80%] h-full p-4 bg-white shadow-lg overflow-y-auto 
          transition-transform duration-300
          sm:w-1/3 sm:p-6
        "
      >
        <button
          onClick={() => setIsReviewOpen(false)}
          className="absolute top-4 right-4"
        >
          <X size={24} />
        </button>

        <h2 className="mb-2 text-lg font-bold">
          Reviews ({totalReviews})
        </h2>

        <p className="text-sm text-gray-600">WHAT OTHER CUSTOMERS THINK</p>

        <div className="flex items-center gap-1 mt-2 text-lg font-bold">
          {avgRating}
          {renderStars(avgRating)}
        </div>

        <p className="text-sm text-gray-600">
          Based on {totalReviews} customer reviews
        </p>

        <div className="flex justify-between mt-3 text-sm">
          <span>Small</span>
          <span>Spot on</span>
          <span>Large</span>
        </div>

        <div className="relative h-2 mt-1 bg-gray-300 rounded-full">
          <div className="w-1/2 h-full bg-black rounded-full"></div>
        </div>

        <div className="flex justify-between mt-4">
          <div className="flex items-center gap-1">
            <FaFilter className="w-5 h-5 text-gray-600" />
            <button className="text-sm font-semibold text-black">Filter</button>
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-600" htmlFor="sortOptions">
              Sort by:
            </label>
            <select
              id="sortOptions"
              className="p-1 text-sm text-gray-600 border rounded-md"
              value={sortOption}
              onChange={handleSortChange}
            >
              <option value="Most Relevant">Most Relevant</option>
              <option value="Most Newest">Most Newest</option>
              <option value="Highest Rated">Highest Rated</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          {sortedReviews.length > 0 ? (
            sortedReviews.map((review) => (
              <div
                key={review.rating_auto_id}
                className="pb-4 mb-4 border-b"
              >
                <p className="text-sm text-gray-600">{review.date}</p>

                <div className="flex items-center gap-1">
                  {renderStars(review.rating)}
                </div>

                <p className="text-sm font-semibold">{review.customer_name}</p>

                <p className="text-sm text-gray-600">{review.review}</p>

                {review.review_image && (
                  <img
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/RatingReview/${review.review_image}`}
                    alt="Review"
                    className="object-cover w-20 h-20 mt-2"
                  />
                )}
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-600">No reviews available.</p>
          )}
        </div>
      </div>
    </div>
  )}
</div> */}


            {/* Accordion for Additional Info */}
            <div className="mt-8 space-y-4">
              {productSpecification.map((section) => (
                section.title && section.description && (
                  <details key={section} className="pb-2 border-b group">
                    <summary className="flex items-center justify-between text-sm font-semibold cursor-pointer">
                      {section.title}
                      <span className="transition-transform group-open:rotate-180">
                        <RiArrowDropDownLine className="w-6 h-6" />{" "}
                        {/* Dropdown Arrow Icon */}
                      </span>
                    </summary>
                    <p className="mt-2 text-sm text-gray-500">
                      {section.description}
                    </p>
                  </details>
                )
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* SHOP THE LOOK SECTION */}
      <div className="w-[85%] bg-white p-4 md:p-6 m-auto rounded-2xl shadow-lg flex flex-col md:flex-row gap-6 mt-10">

        {/* Vertical SHOP THE LOOK text */}


        {/* LEFT: TEXT + MAIN IMAGE */}
        <div className="relative flex items-center justify-center flex-1 bg-gray-50 rounded-2xl md:justify-end">
          <h2 className="vertical-gradient-text p-2 
                  text-[50px] font-bold "
          >
            SHOP THE LOOK
          </h2>
          {/* Main Image */}
          <img
            src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${productImages[0]?.product_image}`}
            alt="Main Look"
            className="w-[200px] md:w-full md:w-[100%] h-[400px] md:max-h-[500px] object-cover rounded-2xl"
          />

          {/* Floating Plus Icons */}
          <button
            onClick={() => setOpenLookPopup(true)}
            className="absolute flex items-center justify-center w-6 h-6 transform -translate-x-1/2 bg-white rounded-full shadow-lg top-12 md:top-20 left-1/2 md:w-6 md:h-6 md:pointer-events-none"
          >
            <FiPlus className="text-base md:text-lg" />
          </button>

          <button
            onClick={() => setOpenLookPopup(true)}
            className="absolute flex items-center justify-center w-6 h-6 transform -translate-x-1/2 bg-white rounded-full shadow-lg bottom-12 md:bottom-20 left-1/2 md:w-6 md:h-6 md:pointer-events-none "
          >
            <FiPlus className="text-base md:text-lg" />
          </button>

        </div>

        {/* RIGHT SIDE PRODUCT CARDS */}
        {/* RIGHT SIDE PRODUCT CARDS */}
        <div className="relative flex-[1] w-[50%] hidden md:block">

          {/* LEFT ARROW */}
          <button
            onClick={scrollShopLookLeft}
            className="absolute z-10 flex items-center justify-center -translate-y-1/2 bg-white rounded-full shadow-md left-2 top-1/2 w-9 h-9 hover:bg-gray-100"
          >
            <IoIosArrowRoundBack size={20} />
          </button>

          {/* RIGHT ARROW */}
          <button
            onClick={scrollShopLookRight}
            className="absolute z-10 flex items-center justify-center -translate-y-1/2 bg-white rounded-full shadow-md right-2 top-1/2 w-9 h-9 hover:bg-gray-100"
          >
            <IoIosArrowRoundForward size={20} />
          </button>

          <div
            ref={shopLookSliderRef}
            className="flex-[1] overflow-x-auto scroll-smooth"
          >
            <div className="flex gap-4 md:gap-6 snap-x snap-mandatory">

              {crossSellingProducts.map((product) => (
                <div
                  key={product.productAutoId}
                  className="w-[55%] sm:w-[28%] md:w-[42%] flex-shrink-0 snap-start
               border rounded-2xl overflow-hidden shadow-sm
               hover:shadow-md transition cursor-pointer"
                  onClick={() => setSelectedCrossProduct(product)}
                >
                  {/* PRODUCT IMAGE */}
                  <div className="relative">
                    <img
                      src={product.images?.[0] || "https://placehold.co/400x400"}
                      alt={product.name}
                      className="w-full h-[180px] sm:h-[200px] md:h-[220px] object-cover"
                    />

                    {/* HEART ICON */}
                    {/* <button
        onClick={(e) => {
          e.stopPropagation();
          handleWishlistToggle(e);
        }}
        className={`absolute top-2 right-2 bg-white shadow-md
          w-7 h-7 rounded-full flex items-center justify-center
          ${wishlisted ? "text-red-500" : "text-gray-500"}`}
      >
        {wishlisted ? <FaHeart /> : <FiHeart />}
      </button> */}
                  </div>

                  {/* PRODUCT DETAILS */}
                  <div className="p-3">
                    <p className="font-semibold line-clamp-2">{product.name}</p>

                    <p className="mt-1 text-xs text-gray-500">
                      SKU: {formatSKU(product.productAutoId)}
                    </p>

                    <div className="flex items-center justify-between mt-2">
                      <p className="font-bold text-black">
                        ₹{product.price}
                        {product.originalPrice && (
                          <span className="ml-2 text-gray-400 line-through">
                            ₹{product.originalPrice}
                          </span>
                        )}
                      </p>

                      <button
                        className="flex items-center justify-center w-8 h-8 border rounded-xl"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCrossProduct(product);
                        }}
                      >
                        <FiPlus />
                      </button>
                    </div>
                  </div>
                </div>
              ))}


            </div>
          </div>
        </div>
      </div>
      {/* MOBILE ONLY BOTTOM SHEET */}
      {openLookPopup && (
        <div className="fixed inset-0 bg-black/40 z-[999] flex items-end md:hidden">
          <div className="bg-white w-full rounded-t-3xl p-2 shadow-xl max-h-[80vh] overflow-y-auto">

            {/* Header */}
            <div className="flex items-center justify-between mt-4 mb-4">
              <h2 className="text-lg font-bold">SHOP THE LOOK</h2>
              <button
                onClick={() => setOpenLookPopup(false)}
                className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full"
              >
                ✕
              </button>
            </div>

            {/* PRODUCT CARDS SAME AS RIGHT SIDE */}
            <div className="relative flex-[1] w-full ">

              {/* LEFT ARROW */}
              <button
                onClick={scrollShopLookLeft}
                className="absolute z-10 flex items-center justify-center -translate-y-1/2 bg-white rounded-full shadow-md left-2 top-1/2 w-9 h-9 hover:bg-gray-100"
              >
                <IoIosArrowRoundBack size={20} />
              </button>

              {/* RIGHT ARROW */}
              <button
                onClick={scrollShopLookRight}
                className="absolute z-10 flex items-center justify-center -translate-y-1/2 bg-white rounded-full shadow-md right-2 top-1/2 w-9 h-9 hover:bg-gray-100"
              >
                <IoIosArrowRoundForward size={20} />
              </button>

              <div
                ref={shopLookSliderRef}
                className="flex-[1] overflow-x-auto scroll-smooth"
              >
                <div className="flex gap-4 md:gap-6 snap-x snap-mandatory">

                  {crossSellingProducts.map((product) => (
                    <div
                      key={product.productAutoId}
                      className="w-[55%] sm:w-[28%] md:w-[42%] flex-shrink-0 snap-start
               border rounded-2xl overflow-hidden shadow-sm
               hover:shadow-md transition cursor-pointer"
                      onClick={() => setSelectedCrossProduct(product)}
                    >
                      {/* PRODUCT IMAGE */}
                      <div className="relative">
                        <img
                          src={product.images?.[0] || "https://placehold.co/400x400"}
                          alt={product.name}
                          className="w-full h-[180px] sm:h-[200px] md:h-[220px] object-cover"
                        />

                        {/* HEART ICON */}
                        {/* <button
        onClick={(e) => {
          e.stopPropagation();
          handleWishlistToggle(e);
        }}
        className={`absolute top-2 right-2 bg-white shadow-md
          w-7 h-7 rounded-full flex items-center justify-center
          ${wishlisted ? "text-red-500" : "text-gray-500"}`}
      >
        {wishlisted ? <FaHeart /> : <FiHeart />}
      </button> */}
                      </div>

                      {/* PRODUCT DETAILS */}
                      <div className="p-3">
                        <p className="font-semibold line-clamp-2">{product.name}</p>

                        <p className="mt-1 text-xs text-gray-500">
                          SKU: {formatSKU(product.productAutoId)}
                        </p>

                        <div className="flex items-center justify-between mt-2">
                          <p className="font-bold text-black">
                            ₹{product.price}
                            {product.originalPrice && (
                              <span className="ml-2 text-gray-400 line-through">
                                ₹{product.originalPrice}
                              </span>
                            )}
                          </p>

                          <button
                            className="flex items-center justify-center w-8 h-8 border rounded-xl"
                            onClick={(e) => {
                              e.stopPropagation();           // prevent card click
                              navigate(`/product-detail/${product.productAutoId}`);
                            }}
                          >
                            <FiPlus />
                          </button>

                        </div>
                      </div>
                    </div>
                  ))}


                </div>
              </div>
            </div>
          </div>
        </div>
      )}




      {/*Style with< */}
      <div className={`px-0 mt-5 sm:px-6 lg:px-8 ${webFont}`}>
        <div className="mx-auto max-w-7xl">
          {/* Section Title - Centered and better spacing */}
          <h2 className="mb-8 text-2xl font-bold text-center">
            Similar Products
          </h2>

          {/* Product Carousel Container */}
          <div className="relative">
            {/* Product List - Improved layout and spacing */}
            <div className="flex gap-6 px-0 pb-4 overflow-x-auto scrollbar-hide">
              {products.map((product) => (
                <Link
                  key={product.product_auto_id}
                  to={`/product-detail/${product.product_auto_id}`}
                  className="
  no-underline text-inherit flex-shrink-0
  w-[52%]         /* 2 cards per row on mobile */
  sm:w-64         /* standard width on small screens */
  md:w-72 lg:w-80 /* your original desktop width */
  transition-transform hover:scale-[1.02]
"

                >
                  {/* Product Card Container */}
                  <div className="relative flex flex-col items-center overflow-hidden transition-shadow bg-white rounded-lg shadow-sm hover:shadow-md">
                    {/* Product Image - Fixed aspect ratio */}
                    <div className=" relative w-full aspect-[3/4] bg-transparent h-64">
                      {product.product_images.slice(0, 1).map((image) => (
                        <img
                          src={
                            product.product_images?.[0]?.product_image
                              ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                              : "https://placehold.co/300x400"
                          }
                          alt={product.product_name}
                          className="object-contain w-full h-full"
                          loading="lazy"
                        />

                      ))}
                      {/* Heart Icon - Better positioning and styling */}
                      {/* <button
                        className="absolute p-2 transition-colors bg-white rounded-full shadow-md bottom-4 right-4 hover:bg-gray-100"
                        onClick={(e) => {
                          e.preventDefault();
                          
                        }}
                      >
                        <SlHeart size={20} className="text-gray-700" />
                      </button> */}
                    </div>

                    {/* Product Details - Better typography and spacing */}
                    <div className="w-full p-4 text-center">
                      <h3 className="mb-1 text-sm font-medium text-gray-900 line-clamp-2">
                        {product.product_name}
                      </h3>
                      <p className="text-sm text-center text-gray-800 md:text-base">
                        <span className="mr-4 font-bold">Rs. {product.final_product_price}</span>
                        {product.offer_percentage > 0 && (
                          <span className="text-gray-500 line-through">Rs. {product.product_price}</span>
                        )}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Optional Arrows - Uncomment if needed */}
            {/*
      <button className="absolute z-10 p-2 -translate-y-1/2 bg-white rounded-full shadow-md left-4 top-1/2 hover:bg-gray-100">
        <IoIosArrowRoundBack size={24} />
      </button>
      <button className="absolute z-10 p-2 -translate-y-1/2 bg-white rounded-full shadow-md right-4 top-1/2 hover:bg-gray-100">
        <IoIosArrowRoundForward size={24} />
      </button>
      */}
          </div>
        </div>
      </div>

      {selectedCrossProduct && (
        <div className="fixed inset-0 z-40 flex justify-end bg-opacity-30 backdrop-blur-sm">
          {/* Left side: Vertically scrollable images */}
          <div className="w-1/2 sm:w-[600px] h-full overflow-y-auto">
            {selectedCrossProduct.images && selectedCrossProduct.images.length > 0 ? (
              selectedCrossProduct.images.map((image, index) => (
                <div key={index} className="w-full h-full mb-2">
                  <img
                    src={image}
                    alt={`${selectedCrossProduct.name} ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                </div>
              ))
            ) : (
              <div className="w-full h-[400px]">
                <img
                  src="https://placehold.co/600x400"
                  alt="No image available"
                  className="object-cover w-full h-full"
                />
              </div>
            )}
          </div>
          {/* Right side: Existing content */}
          <div className="w-1/2 sm:w-[500px] h-full bg-white shadow-lg transform transition-transform z-50 flex flex-col">
            <div className="flex items-center justify-between px-4 py-3">
              <p className="mb-0 text-lg font-bold text-black" onClick={() => setSelectedCrossProduct(null)}>
                CHOOSE OPTION
              </p>
              <button className="text-xl text-gray-500" onClick={() => setSelectedCrossProduct(null)}>
                <LiaTimesSolid />
              </button>
            </div>
            <div className="w-full h-px bg-gray-400"></div>
            <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
              <h2 className="text-lg font-bold truncate">{selectedCrossProduct.name}</h2>
              <p className="mt-2 text-gray-600 truncate">{selectedCrossProduct.description}</p>
              <div className="flex items-center justify-start mt-1">
                <span className="mr-3 text-lg font-semibold">
                  {`Rs. ${crossSelectedSizePrice ? crossSelectedSizePrice : selectedCrossProduct.price}`}
                </span>
                {selectedCrossProduct.discount && parseFloat(selectedCrossProduct.discount.replace("% off", "")) > 0 && (
                  <span className="text-sm text-gray-500 line-through">{selectedCrossProduct.originalPrice}</span>
                )}
              </div>
              {selectedCrossProduct.size?.length > 0 && (
                <>
                  <div className="mt-3">
                    <div className="flex items-center justify-between">
                      <label className="font-bold">Select</label>
                      {(chartImage || chartImage2) && (
                        <div className="text-end">
                          <button
                            className="flex items-center justify-end gap-1 mt-2 text-black"
                            onClick={fetchCrossSizeChart}
                          >
                            <TfiRulerAlt className="text-base" />
                            {crossShowSizeChart ? (
                              <span className="underline">Size Chart</span>
                            ) : (
                              <span className="underline">Size Chart</span>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="flex gap-2 mt-2">
                      {Array.isArray(selectedCrossProduct?.size) &&
                        selectedCrossProduct.size.map((sizeObj, index) => {
                          const actualStock = parseInt(sizeObj.size_stock, 10);
                          const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
                          const isSelected = crossSelectedSize === sizeObj.size_name;
                          const displayStock = showStock ? randomStocks[index] : actualStock;
                          const showStockLabel = actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;
                          return (
                            <div key={sizeObj.size_auto_id} className="relative">
                              <button
                                className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
                                              ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed disabled-overlay" : ""}
                                              ${!isDisabled && isSelected ? "text-white" : ""}`}
                                style={{
                                  backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                                  borderColor: !isDisabled && isSelected ? themeColor : undefined,
                                  color: !isDisabled && isSelected ? "#ffffff" : undefined,
                                }}
                                onClick={() => {
                                  if (isDisabled) return;
                                  setCrossSelectedSize(sizeObj.size_name);
                                  setCrossSelectedSizeId(sizeObj.size_auto_id);
                                  setCrossSelectedStock(actualStock);
                                  const sizePriceObj = selectedCrossProduct.get_price_lists[index];
                                  if (!sizePriceObj || !sizePriceObj.final_size_price) {
                                    setCrossMessage("Size price not available");
                                    clearCrossMessage();
                                    return;
                                  }
                                  setCrossSelectedSizePrice(sizePriceObj.final_size_price);
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor = themeColor;
                                    e.currentTarget.style.color = "#ffffff";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                    e.currentTarget.style.color = "#000000";
                                  }
                                }}
                                disabled={isDisabled}
                              >
                                <span className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}>
                                  {sizeObj.size_name}
                                </span>
                                {showStockLabel && (
                                  <span
                                    className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                    style={{ backgroundColor: themeColor }}
                                  >
                                    {displayStock} left
                                  </span>
                                )}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  {crossShowSizeChart && chartImage && (
                    <div className="p-2 mt-2 border rounded-lg">
                      <h3 className="mb-2 text-lg font-bold">Size Chart</h3>
                      <img src={chartImage} alt="Size Chart" className="w-full h-auto rounded" />
                      <h3 className="mb-2 text-lg font-bold">International Size Chart</h3>
                      <img src={chartImage2} alt="Size Chart" className="w-full h-auto rounded" />
                    </div>
                  )}
                </>
              )}
              <div className="relative mt-5">
                {crossMessage && (
                  <div
                    className="p-2 mt-2 text-sm text-center bg-white"
                    style={{ color: crossMessage.includes("successfully") ? "green" : "red" }}
                  >
                    {crossMessage}
                  </div>
                )}
                <div className="flex flex-row items-center gap-1">
                  <div className="flex items-center">
                    <button
                      className="bg-white px-2 py-[12px] border-l-2 border-t-2 border-b-2 border-gray-200 rounded-l-full"
                      onClick={() => setCrossQuantity(Math.max(1, crossQuantity - 1))}
                    >
                      <FaMinus />
                    </button>
                    <input
                      type="number"
                      min="1"
                      value={crossQuantity}
                      onChange={(e) => {
                        const value = Math.max(1, parseInt(e.target.value));
                        setCrossQuantity(value);
                      }}
                      className="w-11 text-center border-t-2 border-b-2 border-gray-200 py-[8px] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none"
                    />
                    <button
                      className="bg-white px-2 py-[12px] border-r-2 border-t-2 border-b-2 border-gray-200 rounded-r-full"
                      onClick={() => setCrossQuantity(crossQuantity + 1)}
                    >
                      <FaPlus />
                    </button>
                  </div>
                  <button
                    className={`flex-1 text-white py-[12px] rounded-full border ${selectedCrossProduct.size?.length > 0 && (!crossSelectedSize || crossSelectedStock === 0) ? "bg-gray-400 cursor-not-allowed" : "cursor-pointer"}`}
                    style={{
                      backgroundColor: selectedCrossProduct.size?.length > 0 && (!crossSelectedSize || crossSelectedStock === 0) ? "#ccc" : themeColor,
                    }}
                    onMouseEnter={(e) => {
                      if (!(selectedCrossProduct.size?.length > 0 && (!crossSelectedSize || crossSelectedStock === 0))) {
                        const darkenedColor = darkenHexColor(themeColor, 0.15);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = selectedCrossProduct.size?.length > 0 && (!crossSelectedSize || crossSelectedStock === 0) ? "#ccc" : themeColor;
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCrossMessage(null);
                      const moq = parseInt(selectedCrossProduct?.moq || "1", 10);
                      const qty = parseInt(crossQuantity, 10);
                      if (selectedCrossProduct.size?.length !== 0 && (!crossSelectedSize || !crossSelectedSizePrice)) {
                        setCrossMessage("Please select a size");
                        clearCrossMessage();
                        return;
                      }
                      if (selectedCrossProduct.size?.length !== 0 && crossSelectedStock === 0) {
                        setCrossMessage("Selected size is out of stock");
                        clearCrossMessage();
                        return;
                      }
                      if (qty < moq) {
                        setCrossMessage(`Minimum order quantity is ${moq}`);
                        clearCrossMessage();
                        return;
                      }
                      const payload = {
                        product_auto_id: selectedCrossProduct.productAutoId,
                        added_by_id: selectedCrossProduct.user_auto_id,
                        cart_quantity: qty,
                        ...(selectedCrossProduct.size?.length !== 0 && {
                          size: crossSelectedSizeId,
                          size_price: crossSelectedSizePrice,
                        }),
                      };
                      try {
                        const res = await addToCart(payload);

                        // 🚫 ALREADY IN CART (CHECK FIRST)
                        if (res?.message && res.message.toLowerCase().includes("already")) {
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });
                          return;
                        }

                        // ✅ SUCCESS
                        if (res?.status === "1") {
                          setCartMessage({
                            text: res.message || "Added to cart",
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setCartMessage({
                            text: res?.message || "Unable to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCrossMessage(error.message);
                        clearCrossMessage();
                        console.log("Failed to add to cart -", error);
                      }
                    }}
                  >
                    {selectedCrossProduct.size?.length === 0
                      ? `Add to Cart | ₹ ${selectedCrossProduct.price}`
                      : !crossSelectedSize
                        ? "SELECT A SIZE"
                        : crossSelectedStock === 0
                          ? "Size Out of Stock"
                          : `Add to Cart | ₹ ${crossSelectedSizePrice}`}
                  </button>
                </div>
                <div className="mt-4 text-center">
                  <Link to={`/product-detail/${selectedCrossProduct.productAutoId}`} className="text-inherit">
                    <button className="text-black underline">View Details</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {faqs.length > 0 && (
        <section className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </section>
      )}

      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map(faq => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      )}



    </>
  );
};

export default ProductDetail1;